module.exports = __webpack_public_path__ + "img/aboutus.9d0b0a45.svg";